module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/flash-black-video-background.b33ff201.jpg";